import React, { useState } from "react";
import { UserScreen } from "../../layouts/user-screen.tsx";
import { FontStyles } from "../../utils/font-styles.ts";
import { Button } from "../../components/buttons/button.tsx";
import { Alert } from "../../components/alerts/alert.tsx";

const textStyle = `font-normal ${FontStyles[`body-l`]}`;

interface ResetEmailProps {
  onSubmit(email: string): Promise<void>;
  email: string;
}

export const ResetEmailSentScreen: React.FC<ResetEmailProps> = (props) => {
  const bgImage = "/static/images/web-promo-pink-narrow.webp";
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onResend = async () => {
    setLoading(true);

    try {
      await props.onSubmit(props.email);
      setLoading(false);
      setSent(true);
    } catch {
      setLoading(false);
    }
  };

  return (
    <UserScreen image={bgImage} headerText={"Check your inbox"} dismissible={false}>
      <div className="flex flex-col gap-4.5 md:gap-6 relative px-4.5 pb-5 pt-4.5 md:px-7.5 md:pb-7.5 md:pt-6">
        {sent && (
          <Alert
            color="green"
            message={`Make sure to check your spam or junk folders.`}
            style="outlined"
            title="Password reset email resent"
            renderLeadingIcon={() => <i className="fa-sharp fa-regular text-2xl fa-circle-check" />}
          />
        )}
        <p className={textStyle}>
          We have sent you an email with instructions on how to reset your password. This should arrive in a few
          moments. Make sure to check your spam folder.
        </p>
        <p className={textStyle}>Cannot find the email? No problem. Just click below:</p>
        <Button
          label="Resend password reset email"
          colorVariant="primary"
          loading={loading}
          loadingLabel="Sending email..."
          variant="outlined"
          disabled={loading}
          onClick={() => void onResend()}
        />
      </div>
    </UserScreen>
  );
};
